export default {
  /* eslint-disable */

  namespaced: true,
  state: {
    sidebarClose: true,
    sidebarStatic: false,
    sidebarActiveElement: null,
    activeTab: '',
    activeOption: '',
    bookingsWideView: 9,
    busWideView: 3,
  },
  mutations: {
    toggleSidebar(state) {
      const nextState = !state.sidebarStatic;

      localStorage.sidebarStatic = nextState;
      state.sidebarStatic = nextState;
    },
    switchSidebar(state, value) {
      if (value) {
        state.sidebarClose = value;
      } else {
        state.sidebarClose = !state.sidebarClose;
      }
    },
    handleSwipe(state, e) {
      if ('ontouchstart' in window) {
        if (e.direction === 4) {
          state.sidebarClose = false;
        }

        if (e.direction === 2 && !state.sidebarClose) {
          state.sidebarClose = true;
          return;
        }
      }
    },
    changeSidebarActive(state, index) {
      state.sidebarActiveElement = index;
    },

    // which tab and action is currently active
    setActiveTab(state, value) {
      state.activeTab = value;
    },
    setActiveOption(state, value) {
      state.activeOption = value;
    },
    setActiveTabAndOption(state, value) {
      state.activeTab = value.tab
      state.activeOption = value.option
    },
    toggleBookingsBusViewWidth(state) {
      if ( state.bookingsWideView == 12 ) {
        state.bookingsWideView = 9
        state.busWideView = 3
      } else {
        state.bookingsWideView = 12
        state.busWideView = 0
      }
    },
  },
  actions: {
    toggleSidebar({ commit }) {
      commit('toggleSidebar');
    },
    switchSidebar({ commit }, value) {
      commit('switchSidebar', value);
    },
    handleSwipe({ commit }, e) {
      commit('handleSwipe', e);
    },
    changeSidebarActive({ commit }, index) {
      commit('changeSidebarActive', index);
    },

    setActiveTab({ commit }, value) {
      commit('setActiveTab', value);
    },
    setActiveOption({ commit }, value) {
      commit('setActiveOption', value);
    },
    setActiveTabAndOption({commit}, value) {
      commit('setActiveTabAndOption', value)
      //commit('bookings/RESET_EXCURSION_DATA', {}, {root: true})
      //commit('bookings/RESET_PICKUP_DATA', {}, {root: true})
    },
    toggleBookingsBusWideView({commit}) {
      commit('toggleBookingsBusViewWidth')
    },
    async loadData({
      dispatch, commit
    }, data) {
      
      const activeTab = this.getters.activeTab
      const activeOption = this.getters.activeOption

      dispatch("bookings/hasBookingsUnassigned", {}, {root: true})
      dispatch("bookings/hasBookingsOrphanGroup", {}, {root: true})
      dispatch("bookings/hasBookingsUnchecked", {}, {root: true})

      if ( activeTab == 'Excursions' ) {

        dispatch("buses/loadExcursionBuses", {}, {root: true})
        if ( activeOption == "Activity" ) {
          if ( data.reset )
            commit('bookings/RESET_EXCURSION_DATA', {}, {root: true})
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'}, {root: true})
        } else if ( activeOption == 'Excursion') {
          if ( data.reset )
            commit('bookings/RESET_EXCURSION_DATA', {}, {root: true})
          dispatch("bookings/loadBookingsByBusOrdered", {order_by: 'booking__order_1,customer_language'}, { root: true });
        } else if  ( activeOption == 'Path') {
          if ( data.reset )
            commit('buses/RESET_BUSES_PATH', {}, {root: true})
          dispatch("buses/busesPath", {}, {root: true})
        } else if ( activeOption == 'NoService' ) {
          if ( data.reset ) {
            commit('bookings/RESET_EXCURSION_DATA', {}, {root: true})
          }
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_excursion_service: 'False'}, {root: true})
        }
        dispatch("bookings/pickupzoneSummary", {}, {root: true});

      } else if ( activeTab == 'Pickups') {
        // PICKUPS MANAGEMENT
        dispatch("buses/loadPickupBuses", {}, {root: true})

        if (activeOption == 'Stop') {
          if ( data.reset )
            commit('bookings/RESET_PICKUP_DATA', {}, {root: true})
          dispatch("bookings/loadBookingsByStop", false, {root: true})
        } else if ( activeOption == 'Pickup') {
          if ( data.reset )
            commit('bookings/RESET_PICKUP_DATA', {}, {root: true})
          dispatch("bookings/loadBookingsByBusOrdered", {order_by: 'booking__order,customer_language', bus_type: 'Pickup'}, { root: true})
        } else if ( activeOption == 'Excursion') {
          if ( data.reset )
            commit('bookings/RESET_EXCURSION_DATA', {}, {root: true})
          dispatch("bookings/loadBookingsByBusOrdered", {order_by: 'booking__order_1,customer_language', bus_type: 'Excursion'}, { root: true});
        } else if ( activeOption == 'Path') {
          if ( data.reset )
            commit('buses/RESET_BUSES_PATH', {}, {root: true})
          dispatch("buses/busesPath", {}, {root: true})
        } else if ( activeOption == 'NoService' ) {
          if ( data.reset ) 
            commit('bookings/RESET_PICKUP_DATA', {}, {root: true})
            dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_pickup_service: 'False'}, {root: true})
        }
        dispatch("bookings/pickupzoneSummary", {}, {root: true});
      
      } else if ( activeTab == 'Returns' ) {
        // RETURNS MANAGEMENT
        console.log('load returns')
        dispatch("buses/loadReturnBuses", {}, {root: true})

        if (activeOption == 'Stop') {
          if ( data.reset )
            commit('bookings/RESET_RETURN_DATA', {}, {root: true})
          dispatch("bookings/loadBookingsByStop", false, {root: true})
          dispatch("bookings/loadBookingsByReturnBus", false, { root: true })
        }
        else if ( activeOption == 'Path') {
          if ( data.reset )
            commit('buses/RESET_BUSES_PATH', {}, {root: true})
          dispatch("buses/busesPath", {}, {root: true})
        }

      } else if ( activeTab == 'Unassigned') {
        dispatch("bookings/loadBookingsUnassigned", {no_booking_loading: false}, {root: true})
      } else if ( activeTab == 'Orphan' ) {
        dispatch("bookings/loadOrphanBookings", {no_booking_loading: false}, {root: true})
        dispatch("groups/loadGroups", {}, {root:true})
      } else if ( this.activeTab == 'Send') {
        dispatch("buses/sentPlanningData", {}, {root: true}) 
      } else if ( this.activeTab == 'Check' ) {
        dispatch("bookings/loadBookingsByActivityForCheckingOrdered", {order_by: 'id,customer_language', exclude_no_bus_pickup_service: 'False'}, {root: true})
      }
    }
  },
}
